import React from "react";
import _ from "lodash";
import styled from "styled-components";

import theme from "../../styles/theme";
import { PodiumDriver, PodiumDriverSkeleton } from "./PodiumDriverCard";
import { useScheduleContext } from "../../contexts/schedule";
import { buildRowsFromStandings } from "../../utils/helpers/standings";

const PodiumBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const PodiumContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SecondPlace = styled.div`
  flex: 1;
  margin-top: 70px;
  display: none;
  @media (min-width: ${theme.breakpointsCustom.md}px) {
    height: auto;
    display: flex;
  }
`;

const FirstPlace = styled.div`
  flex: 1;
  margin-right: 8px;
  margin-left: 8px;
  @media (max-width: ${theme.breakpointsCustom.md}px) {
    display: flex;
    justify-content: center;
    margin-right: 0px;
    margin-left: 0px;
  }
`;

const ThirdPlace = styled.div`
  flex: 1;
  margin-top: 70px;
  display: none;
  @media (min-width: ${theme.breakpointsCustom.md}px) {
    height: auto;
    display: flex;
  }
`;

const PoduimDrivers = ({ children, drivers, seasonId }) => {
  const { seasons } = useScheduleContext();

  const lastFinishedRaceIndex = _.findLastIndex(
    seasons[seasonId]?.races,
    (race) => race.hasResults,
  );

  const lastFinishedRaceId = seasons[seasonId]?.races[lastFinishedRaceIndex]?.id;
  const driverList = drivers && !Array.isArray(drivers) ? Object.values(drivers)[0] : drivers;
  const rows = buildRowsFromStandings(driverList, { lastFinishedRaceId }).slice(0, 3);
  return (
    <PodiumBlock>
      {children}
      <PodiumContainer>
        <SecondPlace>
          {!drivers ? <PodiumDriverSkeleton /> : <PodiumDriver {...rows[1]} />}
        </SecondPlace>
        <FirstPlace>
          {!drivers ? <PodiumDriverSkeleton /> : <PodiumDriver {...rows[0]} />}
        </FirstPlace>
        <ThirdPlace>
          {!drivers ? <PodiumDriverSkeleton /> : <PodiumDriver {...rows[2]} />}
        </ThirdPlace>
      </PodiumContainer>
    </PodiumBlock>
  );
};

export default PoduimDrivers;
